import { render, staticRenderFns } from "./OtpFormInput.vue?vue&type=template&id=346fec78"
import script from "./OtpFormInput.vue?vue&type=script&lang=ts"
export * from "./OtpFormInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports